import { gql } from "@apollo/client";

export const GET_TIERS = gql`
  query GetTiers {
    getTiers {
      id
      name
      color
      description
      keyFeatures
      riskLevel
      cost
    }
  }
`;